<template>
  <ModalDialog
    ref="contactDialog"
    :title="title"
    :loading="loading"
    :labelCancel="$t('general.cancel')"
    :labelOk="$t('general.save')"
    width="400"
    @ok="onSave"
    @cancel="onCancel"
  >
    <div class="p-0 px-2 pt-2">
      <InputTextValidated
        :label="$t('contacts.name')"
        type="text"
        v-model="contact.name"
      />
      <span class="text-danger" v-if="errors.name">
        {{ errors.name }}
      </span>
    </div>
    <div class="p-0 px-2 pt-2">
      <InputTextValidated
        :label="$t('contacts.email')"
        type="email"
        v-model="contact.email"
      />
      <span class="text-danger" v-if="errors.email">
        {{ errors.email }}
      </span>
    </div>
  </ModalDialog>
</template>

<script>
export default {
  name: 'ContactDialog',

  props: ['contact', 'loading'],

  data() {
    return {
      errors: { email: null, name: null },

      newCoontact: {
        id: null,
        name: null,
        email: null,
      },
    };
  },


  computed: {
    title () {
      if( this.contact.id ) {
        return this.$t('contacts.dlgTitleEditContact');
      }
      return this.$t('contacts.dlgTitleNewContact');
    }
  },
  methods: {
    openModal() {
          this.$refs.contactDialog.openModal();
    },

    closeModal() {
      this.$refs.contactDialog.closeModal();
    },


    onCancel() {
      this.closeModal();
    },

    isValidInput() {
      this.errors = { email: null, name: null };
      if (!this.contact.name) {
        this.errors.name = this.$t('contacts.mandatoryField');
        return false;
      }
      if (!this.contact.email) {
        this.errors.email = this.$t('contacts.mandatoryField');
        return false;
      }
      return true;
    },

    onSave() {
      if (!this.isValidInput()) return;      
      this.$emit('save', this.contact);

    },
  },
  mounted() {
    console.log("Props contact:", this.contact);
    this.newContact = this.contact;
  },
};
</script>

<style></style>
